export const getContractTokensApproveInfo = ({ wallet }, approveContractType) =>
  wallet.getIn(['tokensApproveInfo', 'contracts', approveContractType]);

export const getTokenApproveInfo = ({ wallet }, symbol, approveContractType, property) => {
  const info = wallet.getIn(['tokensApproveInfo', 'tokens', symbol, approveContractType]);

  if (!property) return info;
  return info.get(property);
};
